import {Pipe, PipeTransform} from '@angular/core';
@Pipe({  name: 'orderBy' })
export class OrderrByPipe implements PipeTransform {
  transform(searchDataPaging: Array<any>, args?: any): any {
    return searchDataPaging.sort(function(a, b){
          if(a["arr"][args.property] < b["arr"][args.property]){
            return -1 * args.direction;
          }
          else if(a["arr"][args.property] > b["arr"][args.property]){
            return 1 * args.direction;
          }
          else{
            return 0;
          }
        });
    };
}




// WEBPACK FOOTER //
// ./src/app/shared/pipes/orderby.pipe.ts